__webpack_require__.p = "https://js-static.hirist.tech/production/20.2.0/_next/";